import store from '@/store';

export function setAuth(signInResult) {
	const auth = JSON.stringify(signInResult);
	localStorage.setItem('auth', auth);
	localStorage.setItem('token', signInResult.token);
	store.commit('setAuth', signInResult);
}

export function removeAuth() {
    localStorage.removeItem('auth');
    store.commit('removeAuth');
}

class AuthService {

    isLoggedIn() {
        const auth = this.getAuth();
        return auth && auth.user;
    }
    
    getAuth() {
        const authData = localStorage.getItem('auth');
        if (authData) {
            return JSON.parse(authData);
        } else {
            return null;
        }
    }
    
    initAuth() {
        const auth = this.getAuth();
        if (auth) {
            store.commit('setAuth', auth);
        }
    }
    
    getUserId() {
        return this.isLoggedIn() ? store.state.auth.user.id : null;
    }
    
    logout() {
        removeAuth();
    }
}

export default AuthService;